import { render, staticRenderFns } from "./edit-ads.vue?vue&type=template&id=486a4d24&scoped=true"
import script from "./edit-ads.vue?vue&type=script&lang=js"
export * from "./edit-ads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a4d24",
  null
  
)

export default component.exports